// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalGroup_wrapper__1G7Xi"};